import _ from 'lodash';
export const DEFAULT_TREE_STATE_CACHE_KEY = 'CUSTOM_FIELD_LAYER_TREE_STATE_CACHE';
export default {
    async getCache({ cacheKey }) {
        const caches = JSON.parse(localStorage.getItem('CUSTOM_FIELD_LAYER_TREE_STATE_CACHE'));
        if (!_.isArray(caches)) {
            throw new Error('No Caches');
        }
        const layerCacheItem = _.find(caches, { cacheKey });
        const layerCacheData = _.get(layerCacheItem, 'keys');
        if (layerCacheData && _.isArray(layerCacheData)) {
            return layerCacheData;
        }
        throw new Error('No Caches');
    },
    async saveCache({ cacheKey, keys }) {
        let caches = [];
        try {
            caches = JSON.parse(localStorage.getItem(DEFAULT_TREE_STATE_CACHE_KEY));
        }
        catch (e) {
            caches = [];
        }
        if (!_.isArray(caches)) {
            caches = [];
        }
        const layerCacheItem = _.find(caches, { cacheKey });
        if (layerCacheItem) {
            layerCacheItem.keys = keys;
        }
        else if (caches.length >= 10) {
            caches.shift();
            caches.push({ cacheKey, keys });
        }
        else {
            caches.push({ cacheKey, keys });
        }
        localStorage.setItem(DEFAULT_TREE_STATE_CACHE_KEY, JSON.stringify(caches));
    },
};
